import { wrapToast } from '../utils/toast'

// Create a simple loading system
let loadingElement = null

const showLoading = () => {
  if (loadingElement) return
  
  loadingElement = document.createElement('div')
  loadingElement.id = 'custom-loader'
  loadingElement.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    ">
      <div style="
        background: white;
        padding: 20px;
        border-radius: 8px;
        text-align: center;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      ">
        <div style="
          width: 40px;
          height: 40px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 10px;
        "></div>
        <p style="margin: 0; color: #333;">Please wait loading...</p>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `
  document.body.appendChild(loadingElement)
}

const hideLoading = () => {
  if (loadingElement) {
    document.body.removeChild(loadingElement)
    loadingElement = null
  }
}

// Create a global mixin for Vue 3
const commonMixin = {
  data() {
    return {
      ApiBaseURLUser: process.env.VUE_APP_API_BASEURL_USER,
      ApiBaseURLProvider: process.env.VUE_APP_API_BASEURL_PROVIDER
    }
  },
  methods: {
    customLoader(status) {
      if (status === 'start') {
        showLoading()
      } else if (status === 'close') {
        hideLoading()
      }
    },
    // TB-080 (DEF-170): one definition each. wrapToast (src/utils/toast.js,
    // also applied to this.$toast in main.js) means the text is HTML-escaped and an empty message
    // shows nothing. No message at all (undefined) keeps the generic error.
    displayError (message = 'There is some error!') {
      wrapToast(this.$toast).error(message)
    },
    displaySuccess (message) {
      wrapToast(this.$toast).success(message)
    }
  }
}

// Export the mixin for use in components
export default commonMixin